import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SidebarState {
    isMobileMenuVisible: boolean;
    isMobile: boolean;
}

const initialState: SidebarState = {
    isMobileMenuVisible: false,
    isMobile: false,
};

const sidebarSlice = createSlice({
    name: "sidebar",
    initialState,
    reducers: {
        openMobileMenu: (state) => {
            state.isMobileMenuVisible = true;
        },
        closeMobileMenu: (state) => {
            state.isMobileMenuVisible = false;
        },
        toggleMobileMenu: (state) => {
            state.isMobileMenuVisible = !state.isMobileMenuVisible;
        },
        setIsMobile: (state, action: PayloadAction<boolean>) => {
            state.isMobile = action.payload;
        },
    },
});

export const { openMobileMenu, closeMobileMenu, toggleMobileMenu, setIsMobile } = sidebarSlice.actions;
export default sidebarSlice.reducer;
